export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Яну',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Юни',
    'Юли',
    'Авг',
    'Сеп',
    'Окт',
    'Ное',
    'Дек',
  ],
  months: [
    'Януари',
    'Февруари',
    'Март',
    'Април',
    'Май',
    'Юни',
    'Юли',
    'Август',
    'Септември',
    'Октомври',
    'Ноември',
    'Декември',
  ],
  months_calendar: {
    January: 'Януари',
    February: 'Февруари',
    March: 'Март',
    April: 'Април',
    May: 'Май',
    June: 'Юни',
    July: 'Юли',
    August: 'Август',
    September: 'Септември',
    October: 'Октомври',
    November: 'Ноември',
    December: 'Декември',
  },
  // weekdays
  weekdays: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  weekdays_booking_container: {
    Sunday: 'Неделя',
    Monday: 'Понеделник',
    Tuesday: 'Вторник',
    Wednesday: 'Сряда',
    Thursday: 'Четвъртък',
    Friday: 'Петък',
    Saturday: 'Събота',
  },
  weekdays_calendar: {
    Sun: 'Нд',
    Mon: 'Пн',
    Tue: 'Вт',
    Wed: 'Ср',
    Thu: 'Чт',
    Fri: 'Пт',
    Sat: 'Сб',
  },
  // additional translations
  today: 'Днес',
  tomorrow: 'Утре',
};
